enum OmnivorePosType {
  Test = 'mock',
  Micros3700 = 'micros3700',
  Simphony1 = 'simphony1',
  Simphony18_2 = 'simphony_18_2',
  Simphony2 = 'simphony',
  NcrAloha = 'ncrAloha',
  ParBrink = 'brink',
  Positouch = 'positouch',
}

export { OmnivorePosType };
